import { useSelector } from 'react-redux';
import { selectUserInfo } from 'selectors/api.selector';

export const useUserInfo = () => {
  const userInfoMeta = useSelector(selectUserInfo);
  const { userInfo, userInfoLoading, userInfoError } = userInfoMeta;

  return {
    userInfo,
    loading: userInfoLoading,
    error: userInfoError,
  };
};
